import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import RevisionPage from "./RevisionPage";
import RutasCompletadasPage from "./RutasCompletadasPage";
import MedicionesPage from "./MedicionesPage";
import IncidentsPage from "./IncidentsPage";
import { getRoutesInRevision } from "../services/api";
import { CheckSquare, Gauge, AlertTriangle } from "lucide-react";

export default function GestionRutaPage() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(
    location.state?.tab || (location.state?.openAssignmentId ? "completadas" : "completadas")
  );
  const [revisionRoutes, setRevisionRoutes] = useState([]);

  useEffect(() => {
    getRoutesInRevision()
      .then((d) => setRevisionRoutes(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, []);

  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <div style={s.header}>
        <h1 style={s.title}>Gestión de Rutas</h1>
      </div>

      {/* Tabs */}
      <div style={s.tabBar}>
        <button
          style={{ ...s.tab, ...(activeTab === "completadas" ? s.tabActive : {}) }}
          onClick={() => setActiveTab("completadas")}
        >
          <CheckSquare size={15} />
          Completadas
          {revisionRoutes.length > 0 && (
            <span style={s.badge}>{revisionRoutes.length}</span>
          )}
        </button>
        <button
          style={{ ...s.tab, ...(activeTab === "auditorias" ? s.tabActive : {}) }}
          onClick={() => setActiveTab("auditorias")}
        >
          <Gauge size={15} />
          Auditorías
        </button>
        <button
          style={{ ...s.tab, ...(activeTab === "incidencias" ? s.tabActive : {}) }}
          onClick={() => setActiveTab("incidencias")}
        >
          <AlertTriangle size={15} />
          Incidencias
        </button>
      </div>

      {/* Content */}
      <div style={s.content}>
        {activeTab === "completadas" && (
          <>
            {/* Rutas en revisión — solo si hay alguna */}
            {revisionRoutes.length > 0 && (
              <div style={s.revisionSection}>
                <RevisionPage />
              </div>
            )}
            <RutasCompletadasPage />
          </>
        )}
        {activeTab === "auditorias"  && <MedicionesPage />}
        {activeTab === "incidencias" && <IncidentsPage />}
      </div>
    </div>
  );
}

const s = {
  header: { marginBottom: 4, flexShrink: 0 },
  title: { fontSize: 22, fontWeight: 800, color: "var(--text)", margin: 0, marginBottom: 16 },
  tabBar: {
    display: "flex",
    gap: 4,
    borderBottom: "1px solid var(--border)",
    marginBottom: 24,
    flexShrink: 0,
  },
  tab: {
    display: "flex",
    alignItems: "center",
    gap: 7,
    padding: "10px 20px",
    border: "none",
    background: "none",
    color: "var(--text-2)",
    fontWeight: 700,
    fontSize: 13,
    cursor: "pointer",
    fontFamily: "Montserrat, sans-serif",
    borderBottom: "2px solid transparent",
    marginBottom: -1,
    transition: "all .15s",
  },
  tabActive: {
    color: "#D4620D",
    borderBottom: "2px solid #D4620D",
  },
  badge: {
    background: "#f59e0b",
    color: "#fff",
    borderRadius: 100,
    fontSize: 11,
    fontWeight: 700,
    padding: "1px 7px",
    marginLeft: 2,
  },
  content: { flex: 1, minHeight: 0 },
  revisionSection: {
    marginBottom: 32,
    paddingBottom: 32,
    borderBottom: "2px solid var(--border)",
  },
};
